export class PasswordResetToken {

  constructor(public token: string, public uid?: string, public password?: string) { }
}
